import i18n from 'config/i18n';
import { Control } from 'react-hook-form';

import { getLocale } from 'utils/date';

import { ControlledDatePicker } from 'components/shared';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

const t = i18n.getFixedT(getLocale());

interface Props {
  name: string;
}

export const DistanceRangeFromField: React.FC<Props> = ({ name }) => {
  return (
    <ControlledNumericField
      name={name}
      label={t('adminPortal.arrangements.details.from')}
      variant={'outlined'}
    />
  );
};

export const DistanceRangeToField: React.FC<Props> = ({ name }) => {
  return (
    <ControlledNumericField
      name={name}
      label={t('adminPortal.arrangements.details.to')}
      variant={'outlined'}
    />
  );
};

export const ExpensesPerDistanceField: React.FC<Props> = ({ name }) => {
  return (
    <ControlledNumericField
      name={name}
      label={t('adminPortal.arrangements.details.perKm')}
      variant={'outlined'}
    />
  );
};

export const ExpensesNominalField: React.FC<Props> = ({ name }) => {
  return (
    <ControlledNumericField
      name={name}
      label={t('adminPortal.arrangements.details.nominal')}
      variant={'outlined'}
    />
  );
};

export const ExpensesMaxField: React.FC<Props> = ({ name }) => {
  return (
    <ControlledNumericField
      name={name}
      label={t('adminPortal.arrangements.details.max')}
      variant={'outlined'}
    />
  );
};

export const ValidFromField: React.FC<Props & { control: Control }> = ({
  name,
  control
}) => {
  return (
    <ControlledDatePicker
      name={name}
      label={t('validFrom')}
      control={control}
      variant={'outlined'}
      fullWidth
    />
  );
};

export const ValidToField: React.FC<Props & { control: Control }> = ({
  name,
  control
}) => {
  return (
    <ControlledDatePicker
      name={name}
      label={t('validTo')}
      control={control}
      variant={'outlined'}
      fullWidth
    />
  );
};
